

















































































import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import shipmentStore from '@/stores/ShipmentStore'
import deliveryStore from '@/stores/DeliveryStore'
import { Routes } from '@/router/routes'
import Delivery from '@/dto/deliveries/Delivery'
import { NotifyHelper } from 'vue-kit'

@Component
export default class PopupMenu extends Vue {
  @Prop(Object)
  model: Delivery
  shipmentStore = shipmentStore
  deliveryStore = deliveryStore
  showConfirmDialog: boolean = false
  isShowMenu: boolean = false

  removeDelivery() {
    if (!this.model.id) {
      return
    }

    if (this.$route.params.deliveryId === this.model.id.toString()) {
      this.$router.push({
        name: Routes.deliveries,
      })
    }
    this.deliveryStore
      .removeDelivery(this.model.id)
      .finally(() => (this.isShowMenu = false))
  }

  toggleEnabled() {
    const model = Object.assign({}, this.model)
    model.enabled = !model.enabled

    this.deliveryStore.saveDelivery(model).catch(errors => {
      NotifyHelper.error(
        'Ошибка сохранения. Проверьте что заполнены обязательные поля'
      )

      const deliveryId = (model.id as number).toString()

      this.$router
        .push({
          name: Routes.deliveryEdit,
          params: { deliveryId },
        })
        .then(() => this.$nextTick(() => this.deliveryStore.setErrors(errors)))
    })
  }

  changeShipmentPoint(shipmentPointId: number) {
    const model = Object.assign({}, this.model)
    model.shipmentPointId = shipmentPointId

    this.deliveryStore.saveDelivery(model).then(() => {
      if (model.id) {
        this.deliveryStore.removeDeliveryFromList(model.id)
      }
    })
  }

  get enabledBtnLabel() {
    return this.model.enabled ? 'Отключить' : 'Включить'
  }
}
